<template>
  <div class="stream">
    <div class="toggle-header">
      <select class="select-stream" v-model="streamToggle">
        <option :value="$store.state.org.activeTrust">{{ $store.state.org.name }}</option>
        <option value="All">All Groups</option>
      </select>
    </div>
    <transition name="switchView" mode="out-in">
      <StreamBlocks v-if="streamToggle != 'All'" :blocks="$store.state.org.blocks" :isAll="false"></StreamBlocks>
      <StreamBlocks v-else-if="streamToggle == 'All'" :blocks="$store.state.org.allBlocks" :isAll="true"></StreamBlocks>
    </transition>
  </div>
</template>

<script>
import StreamBlocks from '@trust/components/StreamBlocks.vue'

export default {
  name: 'Stream',
  components: {
    StreamBlocks,
  },
  data() {
      return {
        showCount: 10,
        streamToggle: this.$store.state.org.activeTrust
      }
  },
  computed: {
  },
  mounted() {
    if(this.$store.state.org.userTrusts.length > 0){
      this.$store.commit('fetchAllConcepts');
      this.$store.commit('fetchAllBlocks');
    }
  },
  methods: {
  },
  watch: {
    '$store.state.org.userTrusts' (to){
      if(to.length > 0){
        this.$store.commit('fetchAllConcepts')
        this.$store.commit('fetchAllBlocks')
      }
    }
  }
}

</script>

<style>

.stream {
  width: 100%;
  height: 100%;
  padding: 0px 15px;
  padding-bottom: 80px;
  box-sizing: border-box;
  overflow: scroll;

  display: flex;
  flex-direction: column;
  align-items: center;
}

.stream .toggle-header {
  padding-bottom: 12px;
  width: 100%;
  text-align: center;
  background: var(--beige-300);
  position: sticky;
  top: 0;
  z-index: 100;
}

.stream .toggle-header select {
  font-family: 'Untitled', sans-serif;
  font-size: 14px;
  background: var(--beige-200);
  padding: 0px;
  border-radius: 4px;
  border: 1px solid var(--beige-350);
  cursor: pointer;
}

</style>
